import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(theme => ({
  infoTooltip: {
    marginLeft: theme.spacing(0.5),
    maxHeight: theme.spacing(2),
    display: 'inline-block',
    verticalAlign: 'bottom',
  },
  text: {
    color: theme.palette.common.gray800,
  },
  padding: {
    padding: theme.spacing(0, 2),
  },
  taskTitle: {
    color: theme.palette.common.gray800,
    marginBottom: '10px',
  },
  wrapTaskInfo: {
    marginLeft: '-11px',
    marginTop: '16px',
  },
}));
